// extracted by mini-css-extract-plugin
export default {"filter":"filters_filter__16BSN"};